import { useAnalytics } from "./context";

export const ClinicalAnalyticFilters = () => {
 const { filters, setFilters, filterReport, patientsForFilter } = useAnalytics()

  return (
    <aside>
        <label>
        Questionnaire
        <select
          value={filters.formId}
          onChange={(e) =>
            setFilters({ ...filters, formId: e.target.value as any })
          }
        >
          <option value={"E889A966-B1A6-43FF-BCAA-C3138A0914F7"}>VASQoL</option>
          <option value={"0810E381-D1CD-4996-9C2E-4619A3B566AD"}>SUS</option>
        </select>
      </label>
      <label>
        Date Range
        <select
          value={filters.timeframe}
          onChange={(e) =>
            setFilters({ ...filters, timeframe: e.target.value as any })
          }
        >
          <option value={""}>All</option>
          <option value={"1-month"}>1 month</option>
          <option value={"3-months"}>3 months</option>
          <option value={"6-months"}>6 months</option>
          <option value={"1-year"}>1 year</option>
          <option value={"2-years"}>2 years</option>
        </select>
      </label>

      <label>
        Type of access
        <select
          value={filters.accessType}
          onChange={(e) =>
            setFilters({ ...filters, accessType: e.target.value as any })
          }
        >
          <option value={""}>All</option>
          <option value={"AVF"}>Fistula</option>
          <option value={"AVG"}>Graft</option>
          <option value={"CVC"}>Line</option>
          <option value={"None"}>None</option>
        </select>
      </label>
      <label>
        Patient
        <select
          value={filters.patientCode}
          onChange={(e) =>
            setFilters({ ...filters, patientCode: e.target.value as any })
          }
        >
          <option value="">All</option>
          {patientsForFilter.map((s, idx) => <option key={idx} value={s}>{s}</option>)}
        </select>
      </label>

      <button type="submit" onClick={(e) => {
        e.preventDefault()
        filterReport()
      }}>Filter</button>
    </aside>
  );
};
